import React from 'react';

const Foot = () => {
    return (

        <div className="row foot rounded-bottom">
            <div className="col-md-6">
                <p>Chemical Engineering, BSc.</p>
            </div>
            <div className="col-md-6">
                <p className="float-end">Technologies: React | JS | Django | Python</p>
            </div>
        </div>

    )
}

export default Foot;